import cssVariables from 'tfs.css-variables'

export default {
  tag: {
    backgroundColor: cssVariables.colorGreen,
    color: cssVariables.colorWhite,
    display: 'inline-block',
    borderRadius: '0.5em',
    padding: '0.7em 0.8em 0.6em',
    lineHeight: 1,
  },
}
